@if (application) {
<div
  [title]="application.labelTooltip?.[currentLang] || application.label[currentLang]"
  class="flex justify-center items-center gap-2 px-2 leading-12 h-48"
>
  @if (application.icon && !application.logo) {
  <mat-icon>{{ application.icon }}</mat-icon>
  } @if (!application.icon && application.logo) {
  <!-- eslint-disable-next-line -->
  <img [src]="application.logo" class="inline-block h-24" />
  } @if (expanded) {
  <span class="title text-center text-xl leading-12">
    {{ application.label[currentLang] }}
  </span>
  }
</div>
}
